<ion-content class="ion-padding modal">
  <div class="d-flex ion-justify-content-center">
    <ion-img
      src="/assets/homieGif/paymentSuccess.gif"
      class="success-gif"
    ></ion-img>
  </div>
  <div class="d-flex flex-col ion-align-items-center white-text-color">
    <ion-label class="font700 boldText"> Booking Confirmed! </ion-label>
    <ion-text class="fs-4 font500 padt6">
      Your booking has been confirmed.
    </ion-text>
    <ion-text class="fs-4 font500 padt6 marb10">
      Please check your email for more details.
    </ion-text>
  </div>

  <div class="d-flex flex-col ion-align-items-center white-text-color">
    <ion-label class="font700 ion-padding-top boldText padb10">
      Congratulations
    </ion-label>
    <ion-label
      *ngIf="priceDetail?.campaignDetail?.promoType === 'CASHBACK'"
      class="font700 padb10 boldText"
    >
      You've Earned
      {{
        priceDetail?.campaignDetail?.promoValue
          | currency : priceDetail?.currency
      }}</ion-label
    >
  </div>

  <hr />

  <div class="fs-2 font400 ion-text-center white-text-color padb10 padt10">
    <ion-label>Payment receipt has been sent to your email</ion-label>
  </div>

  <ion-button
    class="primary-btn ion-margin-top"
    expand="block"
    (click)="navigateToHome()"
    >Done</ion-button
  >

  <div class="fs-2 font400 ion-text-center ion-padding-top ion-padding-bottom white-text-color">
    <ion-label class="help" (click)="help()">Need help with this transaction?</ion-label>
  </div>
</ion-content>
